import { useTranslation } from 'react-i18next';
import AuditsContainer from '~/containers/audit/audit-overview.container';
import PageContainer from '~/containers/page.container';
import useCompanyContext from '~/hooks/company-scope.hook';
import { Page } from '~/types';
import capitalize from '~/utils/string';

const Audits: Page = () => {
  const { t } = useTranslation();
  const { company } = useCompanyContext();

  if (!company) {
    return (
      <PageContainer>
        <p>{capitalize(t('kies eerst een bedrijf'))}</p>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <AuditsContainer />
    </PageContainer>
  );
};

Audits.isPublic = false;

export default Audits;
